import styled from 'styled-components'

export const CheckContainer = styled.div`
  white-space: nowrap;
  margin-left: 15px;
  margin-top: 10px;
`
